import { RecommendationsSection } from "@/components/organisms/RecommendationsSection";

export const DashboardMain = () => {
  return (
    <main className="flex-1">
      <RecommendationsSection />
    </main>
  );
};
